export const MAX_LABEL_LENGTH = 100;
export const MAX_TITLE_LENGTH = 100;
export const MAX_CONCEPT_LENGTH = 100;
export const MAX_NOTATION_LENGTH = 50;
export const MAX_CONCEPTSCHEME_TITLE_LENGTH = 100;
export const MAX_CONCEPTSCHEME_DESC_LENGTH = 500;
export const MAX_COLLECTION_TITLE_LENGTH = 100;
export const MAX_COLLECTION_DESC_LENGTH = 500;
export const MAX_DEFINITION_LENGTH = 5000;
export const MAX_IRI_LENGTH = 500;

const SKOS = "http://www.w3.org/2004/02/skos/core#";
const OWL = "http://www.w3.org/2002/07/owl#";

export const NOTE_FIELDS =
    [
        {
            title: "Definitions",
            message: "Definition",
            property: "definition",
            multiline: true,
            placeholder: "Enter definition text"
        },
        {
            title: "Examples",
            message: "Example",
            property: "example",
            multiline: true,
            placeholder: "Enter example text"
        },
        {
            title: "Editorial Notes",
            message: "Editorial Note",
            property: "editorialNote",
            multiline: true,
            placeholder: "Enter note text"
        },
        {
            title: "Scope Notes",
            message: "Scope Note",
            property: "scopeNote",
            multiline: true,
            placeholder: "Enter note text"
        },
        {
            title: "History Notes",
            message: "History Note",
            property: "historyNote",
            multiline: true,
            placeholder: "Enter note text"
        },
        {
            title: "Change Notes",
            message: "Change Note",
            property: "changeNote",
            multiline: true,
            placeholder: "Enter note text"
        }
    ];

export const EXPANDED_NOTE_FIELDS = [
    {
        title: "Preferred Labels",
        onePerLang: true,
        message: "Preferred Label",
        property: "prefLabel",
        pairwise: "altLabel",
        maxLength: 250,
        multiline: false,
        placeholder: "Enter label text"
    },
    {
        title: "Alternative Labels",
        message: "Alternative Label",
        property: "altLabel",
        pairwise: "prefLabel",
        maxLength: 250,
        multiline: false,
        placeholder: "Enter label text"
    },
    ...NOTE_FIELDS
];

export const SKOS_DATATYPE_CONFIGURATION = {
    "altLabel": {
        "displayName": "Alternative Label",
        "iri": SKOS + "altLabel",
        "lang": true
    },
    "changeNote": {
        "displayName": "Change Note",
        "iri": SKOS + "changeNote",
        "lang": true
    },
    "deprecated": {
        "displayName": "Deprecated",
        "iri": OWL + "deprecated",
        "lang": false
    },
    "definition": {
        "displayName": "Definition",
        "iri": SKOS + "definition",
        "lang": true
    },
    "editorialNote": {
        "displayName": "Editorial Note",
        "iri": SKOS + "editorialNote",
        "lang": true
    },
    "example": {
        "displayName": "Example",
        "iri": SKOS + "example",
        "lang": true
    },
    "hiddenLabel": {
        "displayName": "Hidden Label",
        "iri": SKOS + "hiddenLabel",
        "lang": true
    },
    "historyNote": {
        "displayName": "History Note",
        "iri": SKOS + "historyNote",
        "lang": true
    },
    "notation": {
        "displayName": "Notation",
        "iri": SKOS + "notation",
        "lang": false
    },
    "prefLabel": {
        "displayName": "Preferred Label",
        "iri": SKOS + "prefLabel",
        "lang": true
    },
    "scopeNote": {
        "displayName": "Scope Note",
        "iri": SKOS + "scopeNote",
        "lang": true
    }
};

export const SKOS_OBJECT_CONFIGURATION = {
    "broader": {
        "displayName": "Broader",
        "colour": "#212121",
        "iri": SKOS + "broader"
    },
    "closeMatch": {
        "displayName": "Close Match",
        "colour": "#212121",
        "iri": SKOS + "closeMatch"
    },
    "exactMatch": {
        "displayName": "Exact Match",
        "colour": "#212121",
        "iri": SKOS + "exactMatch"
    },
    "inScheme": {
        "displayName": "In Scheme",
        "colour": "#212121",
        "iri": SKOS + "inScheme"
    },
    "narrower": {
        "displayName": "Narrower",
        "colour": "#212121",
        "iri": SKOS + "narrower"
    },
    "related": {
        "displayName": "Related",
        "colour": "#212121",
        "iri": SKOS + "related"
    },
    "relatedMatch": {
        "displayName": "Related Match",
        "colour": "#212121",
        "iri": SKOS + "relatedMatch"
    },
    "topConceptOf": {
        "displayName": "Top Concept Of",
        "colour": "#212121",
        "iri": SKOS + "topConceptOf"
    }
};

export const SUGGESTION_TYPE_OPTIONS = [
    {
        "value": "NewConceptSuggestion",
        "label": "New Concept",
        "labelRequired": true,
        "active": true,
        "schemeLevel": true
    },
    {
        "value": "DeprecationSuggestion",
        "label": "Deprecation",
        "active": true
    },
    {
        "value": "MovingSuggestion",
        "label": "Move",
        "explanation": "Concept to move to as narrower concept of",
        "targetMandatory": true,
        "parentTitle": "Select Broader Concept to Remove From",
        "targetTitle": "Select Broader Concept to Move To",
        "active": true
    },
    {
        "value": "RemovalSuggestion",
        "label": "Remove",
        "explanation": "Broader concept from which to remove relationship",
        "requiredRelationship": "broader",
        "parentTitle": "Select Broader Concept to Remove From",
        "active": true
    },
    {
        "value": "SpellingSuggestion",
        "label": "Spelling",
        "active": true
    },
    {
        "value": "SplitSuggestion",
        "label": "Split",
        "active": true
    },
    {
        "value": "TerminologySuggestion",
        "label": "Terminology",
        "active": true
    }
];
